export const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true'
export const CLIENT_SLUG = import.meta.env.VITE_CLIENT_SLUG || 'client'
export const IS_EMBEDDED = import.meta.env.VITE_IS_EMBEDDED === 'true'
